function httpConfig($provide, $httpProvider) {
    $provide.factory('httpInterceptor', ['$q', '$location', '$injector', '$window', ($q, $location, $injector, $window) => ({
        request: config => config,

        requestError: rejection => $q.reject(rejection),

        response: response => response,

        responseError: (rejection) => {
            //Exception hotfix
            if (rejection.config.url.indexOf('/user/confirmation') === -1 && rejection.config.url !== '/api/auth') {
                if (rejection.status === 401) {
                    localStorage.removeItem('kes_email');
                    localStorage.removeItem('kes_token');
                    $window.location.href = '/login?auth=true';
                } else if (rejection.status === 404) {
                    $location.path('/home');
                }
            }
            return $q.reject(rejection);
        },
    })]);

    $httpProvider.interceptors.push('httpInterceptor');
}

export default httpConfig;



// WEBPACK FOOTER //
// ./src/app/httpInterceptor.js